<template>
  <v-menu :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="goToEditProduto(item, false)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Editar produto
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="onClickDelete(item)">
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Remover produto
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="onClickCopy(item)">
        <v-list-item-icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Copiar produto
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <px-confirm-dialog ref="confirm"/>
  </v-menu>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    goToEditProduto(item, isCopy) {
      this.$router.push({
        name: 'main.produto.edicao',
        params: {
          id: item.id,
          isCopy,
        },
      });
    },
    onClickCopy(item) {
      this.goToEditProduto(item, true);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este produto?',
        'O produto será removido e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
};
</script>
